import { Context, Effect, Layer, pipe } from "effect";
import { StripeApiBaseClient } from "./StripeApiBaseClient";
import { StripeApiInstance } from "./StripeApiInstance";
const make = Effect.gen(function*() {
    /**
   * Validate a publishable key.
   *
   * This uses the fact that Stripe will return a 403 error if the key is valid
   * but the key is not authorized to perform the action. If the key was not valid,
   * they would return a 401 error.
   *
   * @param publishableKey - The publishable key to validate.
   * @returns A promise that resolves to a boolean indicating whether the key is valid.
   */ const validatePublishableKey = (publishableKey)=>pipe(StripeApiInstance.make(publishableKey), Effect.flatMap((instance)=>StripeApiBaseClient.make(instance)), Effect.flatMap((use)=>use((stripe)=>stripe.customers.list())), Effect.catchIf((e)=>e._tag === "@open-revenue/stripe/StripeApiError" && e.error.statusCode === 403, (e)=>Effect.succeed(true)), Effect.map(()=>({
                valid: true
            })), Effect.provideServiceEffect(StripeApiInstance, StripeApiInstance.make(publishableKey)));
    /**
   * Validate a secret key.
   *
   * This uses the fact that Stripe will return a 404 error if the key is valid
   * but the key is not authorized to perform the action. If the key was not valid,
   * they would return a 401 or 403 error.
   *
   * @param secretKey - The secret key to validate.
   * @returns A promise that resolves to a boolean indicating whether the key is valid.
   */ const validateSecretKey = (secretKey)=>pipe(StripeApiInstance.make(secretKey), Effect.flatMap((instance)=>StripeApiBaseClient.make(instance)), Effect.flatMap((use)=>use((stripe)=>stripe.customers.retrieve("cus_P88888888888888"))), Effect.catchIf((e)=>e._tag === "@open-revenue/stripe/StripeApiError" && e.error.statusCode === 404, (e)=>Effect.succeed(true)), Effect.map(()=>({
                valid: true
            })), Effect.provideServiceEffect(StripeApiInstance, StripeApiInstance.make(secretKey)));
    return {
        validatePublishableKey,
        validateSecretKey
    };
});
export class StripeApiValidator extends Context.Tag("@open-revenue/stripe/StripeApiValidator")() {
    static make = make;
    static Live = Layer.effect(StripeApiValidator, make);
}
